module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/coinflip-664bc0d5eb09628a.jpg"+" 536w",
        images: [{path: __webpack_public_path__ + "assets/images/coinflip-664bc0d5eb09628a.jpg",width: 536,height: 560}],
        src: __webpack_public_path__ + "assets/images/coinflip-664bc0d5eb09628a.jpg",
        toString: function(){return __webpack_public_path__ + "assets/images/coinflip-664bc0d5eb09628a.jpg"},
        
        width: 536,
        height: 560
      }